require('./aggregatorLoanAndMortgageDetails.scss');

import React from 'react';
import PropTypes from 'prop-types';

// @components
import { OneLineSymbolAmount } from 'commonsComponents/oneLineSymbolAmount';
// import { OKLink } from 'commonsComponents/OKLink';

// @helpers
import { formatAmountObject, getPlainAmountObject } from 'utilities/currencyHelper';

class AggregatorLoanAndMortgageDetails extends React.PureComponent {

    renderItem(product) {
        let amountContainer = null;

        const amountDebt = product.get('debt');
        const alias = product.get('alias');

        if (amountDebt) {
            amountContainer = (
                <div className="col-xs-6 aggregator-loans-mortgages-box-details__item__balance">
                    <OneLineSymbolAmount
                        amountObject={getPlainAmountObject(amountDebt)}
                        amountObjectFormatted={formatAmountObject(getPlainAmountObject(amountDebt), true)}
                    />
                </div>
            );
        }

        return (
            <div className="row aggregator-loans-mortgages-box-details__item">
                <div className="col-xs-6 aggregator-loans-mortgages-box-details__item__alias">
                    {/* <OKLink
                        modifier={'complementary'}
                        to={`/myprofile/global/entities/loans-mortgages/${product.get('id')}`}
                    >
                        {product.get('alias')}
                    </OKLink> */}
                    <span>{alias}</span>
                </div>
                {amountContainer}
            </div>
        );
    }

    render() {
        const { products, isTinkAggregator } = this.props;

        return (
            <div className="aggregator-loans-mortgages-box-details">
                {products.size > 0 ? products.map(item => this.renderItem(item, isTinkAggregator)) : null}
            </div>
        );
    }
}

AggregatorLoanAndMortgageDetails.propTypes = {
    products: PropTypes.object,
    isTinkAggregator: PropTypes.bool
};

export { AggregatorLoanAndMortgageDetails };
